<template>
  <div id="main">
    <app-loading-spinner></app-loading-spinner>

    <div class="content">
      <app-header></app-header>
      <div class="main-container">
        <transition
          :duration="{ enter: 100 }"
          enter-active-class="animated fadeIn">
          <router-view/>
        </transition>
      </div>
    </div>
  <app-footer></app-footer>
  </div>
</template>

<script>
  import LoadingSpinner from '@/components/misc/LoadingSpinner';
  import Header from '@/components/navigation/Header';
  import Footer from '@/components/navigation/Footer';

  export default {
    components: {
      'app-loading-spinner': LoadingSpinner,
      'app-header': Header,
      'app-footer': Footer
    },
    data: () => ({
      duration: {
        enter: 200,
        leave: 100
      }
    })
  }
</script>

<style lang="scss">
  @import '../node_modules/bootstrap/scss/bootstrap.scss';
  @import '../node_modules/bootstrap-vue/dist/bootstrap-vue.css';
  @import '../node_modules/animate.css/animate.min.css';
  @import '../static/application.css';
</style>



// WEBPACK FOOTER //
// src/App.vue